/* tslint:disable */
/* eslint-disable */
/**
 * Resell External Market Integration
 * Api specification for Resell Orders Core
 *
 * The version of the OpenAPI document: 15.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AcceptanceCommitment
 */
export interface AcceptanceCommitment {
    /**
     * 
     * @type {string}
     * @memberof AcceptanceCommitment
     */
    'acceptedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof AcceptanceCommitment
     */
    'acceptanceType'?: AcceptanceCommitmentAcceptanceTypeEnum;
}

export const AcceptanceCommitmentAcceptanceTypeEnum = {
    Manual: 'MANUAL',
    Auto: 'AUTO'
} as const;

export type AcceptanceCommitmentAcceptanceTypeEnum = typeof AcceptanceCommitmentAcceptanceTypeEnum[keyof typeof AcceptanceCommitmentAcceptanceTypeEnum];

/**
 * 
 * @export
 * @interface AdditionalReference
 */
export interface AdditionalReference {
    /**
     * 
     * @type {string}
     * @memberof AdditionalReference
     */
    'id'?: AdditionalReferenceIdEnum;
    /**
     * 
     * @type {string}
     * @memberof AdditionalReference
     */
    'value'?: string;
}

export const AdditionalReferenceIdEnum = {
    Label: 'LABEL',
    Qrcode: 'QRCODE',
    Barcode: 'BARCODE'
} as const;

export type AdditionalReferenceIdEnum = typeof AdditionalReferenceIdEnum[keyof typeof AdditionalReferenceIdEnum];

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressLine'?: string;
    /**
     * 
     * @type {Country}
     * @memberof Address
     */
    'country'?: Country;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'additionalInstructions'?: string;
    /**
     * 
     * @type {Location}
     * @memberof Address
     */
    'location'?: Location;
    /**
     * 
     * @type {ContactInformation}
     * @memberof Address
     */
    'contactInformation'?: ContactInformation;
    /**
     * 
     * @type {GeopoliticalSubdivisions}
     * @memberof Address
     */
    'geopoliticalSubdivisions'?: GeopoliticalSubdivisions;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'userId'?: string;
}
/**
 * 
 * @export
 * @interface Amount
 */
export interface Amount {
    /**
     * 
     * @type {number}
     * @memberof Amount
     */
    'value': number;
    /**
     * 
     * @type {string}
     * @memberof Amount
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof Amount
     */
    'exponent': number;
}
/**
 * 
 * @export
 * @interface BillingCommitment
 */
export interface BillingCommitment {
    /**
     * 
     * @type {string}
     * @memberof BillingCommitment
     */
    'orfeUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingCommitment
     */
    'billingId'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingCommitment
     */
    'billingStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingCommitment
     */
    'billingError'?: string;
}
/**
 * 
 * @export
 * @interface BillingCustomerInfo
 */
export interface BillingCustomerInfo {
    /**
     * 
     * @type {string}
     * @memberof BillingCustomerInfo
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingCustomerInfo
     */
    'companyName'?: string;
    /**
     * 
     * @type {Array<BillingDocument>}
     * @memberof BillingCustomerInfo
     */
    'documents'?: Array<BillingDocument>;
}
/**
 * 
 * @export
 * @interface BillingDocument
 */
export interface BillingDocument {
    /**
     * 
     * @type {string}
     * @memberof BillingDocument
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingDocument
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface Buyer
 */
export interface Buyer {
    /**
     * 
     * @type {string}
     * @memberof Buyer
     */
    'buyerExternalId'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Buyer
     */
    'deliveryAddress'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof Buyer
     */
    'billingAddress'?: Address;
    /**
     * 
     * @type {BillingCustomerInfo}
     * @memberof Buyer
     */
    'billingCustomerInfo'?: BillingCustomerInfo;
}
/**
 * 
 * @export
 * @interface CancellationCommitment
 */
export interface CancellationCommitment {
    /**
     * 
     * @type {string}
     * @memberof CancellationCommitment
     */
    'cancelledAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CancellationCommitment
     */
    'cancellationType'?: CancellationCommitmentCancellationTypeEnum;
}

export const CancellationCommitmentCancellationTypeEnum = {
    Manual: 'MANUAL',
    Auto: 'AUTO',
    Returned: 'RETURNED'
} as const;

export type CancellationCommitmentCancellationTypeEnum = typeof CancellationCommitmentCancellationTypeEnum[keyof typeof CancellationCommitmentCancellationTypeEnum];

/**
 * 
 * @export
 * @interface ContactInformation
 */
export interface ContactInformation {
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    'middleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformation
     */
    'honorific'?: string;
    /**
     * 
     * @type {Phone}
     * @memberof ContactInformation
     */
    'phone'?: Phone;
}
/**
 * 
 * @export
 * @interface Coordinates
 */
export interface Coordinates {
    /**
     * 
     * @type {number}
     * @memberof Coordinates
     */
    'latitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof Coordinates
     */
    'longitude'?: number;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryCommitment
 */
export interface DeliveryCommitment {
    /**
     * 
     * @type {string}
     * @memberof DeliveryCommitment
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryCommitment
     */
    'completedAt'?: string;
    /**
     * 
     * @type {DeliveryStatusInfo}
     * @memberof DeliveryCommitment
     */
    'status'?: DeliveryStatusInfo;
    /**
     * 
     * @type {string}
     * @memberof DeliveryCommitment
     */
    'deliveryAttempts'?: string;
}
/**
 * 
 * @export
 * @interface DeliveryStatusInfo
 */
export interface DeliveryStatusInfo {
    /**
     * 
     * @type {string}
     * @memberof DeliveryStatusInfo
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeliveryStatusInfo
     */
    'statusReason'?: string;
}
/**
 * 
 * @export
 * @interface DisputeCommitment
 */
export interface DisputeCommitment {
    /**
     * 
     * @type {string}
     * @memberof DisputeCommitment
     */
    'startedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeCommitment
     */
    'resolvedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeCommitment
     */
    'status'?: DisputeCommitmentStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DisputeCommitment
     */
    'resolutionType'?: DisputeCommitmentResolutionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DisputeCommitment
     */
    'isPartial'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DisputeCommitment
     */
    'userId'?: string;
    /**
     * 
     * @type {Array<DisputeEvidence>}
     * @memberof DisputeCommitment
     */
    'disputeEvidences'?: Array<DisputeEvidence>;
    /**
     * 
     * @type {string}
     * @memberof DisputeCommitment
     */
    'disputeComment'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeCommitment
     */
    'disputeResolutionComment'?: string;
}

export const DisputeCommitmentStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Close: 'CLOSE'
} as const;

export type DisputeCommitmentStatusEnum = typeof DisputeCommitmentStatusEnum[keyof typeof DisputeCommitmentStatusEnum];
export const DisputeCommitmentResolutionTypeEnum = {
    SellerFavour: 'ON_SELLER_FAVOUR',
    BuyerFavour: 'ON_BUYER_FAVOUR'
} as const;

export type DisputeCommitmentResolutionTypeEnum = typeof DisputeCommitmentResolutionTypeEnum[keyof typeof DisputeCommitmentResolutionTypeEnum];

/**
 * 
 * @export
 * @interface DisputeEvidence
 */
export interface DisputeEvidence {
    /**
     * 
     * @type {string}
     * @memberof DisputeEvidence
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeEvidence
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface Droppoint
 */
export interface Droppoint {
    /**
     * 
     * @type {number}
     * @memberof Droppoint
     */
    'droppointId': number;
    /**
     * 
     * @type {string}
     * @memberof Droppoint
     */
    'droppointName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Droppoint
     */
    'droppointCode'?: string;
    /**
     * 
     * @type {DroppointUserInfo}
     * @memberof Droppoint
     */
    'droppointUserInfo'?: DroppointUserInfo;
}
/**
 * 
 * @export
 * @interface DroppointUserInfo
 */
export interface DroppointUserInfo {
    /**
     * 
     * @type {string}
     * @memberof DroppointUserInfo
     */
    'droppointUserName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DroppointUserInfo
     */
    'droppointUserPhone'?: string;
}
/**
 * 
 * @export
 * @interface Fee
 */
export interface Fee {
    /**
     * 
     * @type {string}
     * @memberof Fee
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Fee
     */
    'type'?: string;
    /**
     * 
     * @type {Amount}
     * @memberof Fee
     */
    'amount'?: Amount;
    /**
     * 
     * @type {number}
     * @memberof Fee
     */
    'effectiveRate'?: number;
    /**
     * 
     * @type {Amount}
     * @memberof Fee
     */
    'taxableAmount'?: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof Fee
     */
    'fixedRate'?: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof Fee
     */
    'taxesRate'?: Amount;
}
/**
 * 
 * @export
 * @interface GeopoliticalSubdivision
 */
export interface GeopoliticalSubdivision {
    /**
     * 
     * @type {StandarizedGeopoliticalSubdivision}
     * @memberof GeopoliticalSubdivision
     */
    'standarized'?: StandarizedGeopoliticalSubdivision;
    /**
     * 
     * @type {string}
     * @memberof GeopoliticalSubdivision
     */
    'freeForm'?: string;
}
/**
 * 
 * @export
 * @interface GeopoliticalSubdivisions
 */
export interface GeopoliticalSubdivisions {
    /**
     * 
     * @type {GeopoliticalSubdivision}
     * @memberof GeopoliticalSubdivisions
     */
    'level1'?: GeopoliticalSubdivision;
    /**
     * 
     * @type {GeopoliticalSubdivision}
     * @memberof GeopoliticalSubdivisions
     */
    'level2'?: GeopoliticalSubdivision;
    /**
     * 
     * @type {GeopoliticalSubdivision}
     * @memberof GeopoliticalSubdivisions
     */
    'level3'?: GeopoliticalSubdivision;
    /**
     * 
     * @type {GeopoliticalSubdivision}
     * @memberof GeopoliticalSubdivisions
     */
    'level4'?: GeopoliticalSubdivision;
}
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'type'?: ImageTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'url'?: string;
}

export const ImageTypeEnum = {
    Detail: 'DETAIL',
    Icon: 'ICON'
} as const;

export type ImageTypeEnum = typeof ImageTypeEnum[keyof typeof ImageTypeEnum];

/**
 * 
 * @export
 * @interface IncidenceCommitment
 */
export interface IncidenceCommitment {
    /**
     * 
     * @type {string}
     * @memberof IncidenceCommitment
     */
    'startedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidenceCommitment
     */
    'resolvedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof IncidenceCommitment
     */
    'incidenceType'?: IncidenceCommitmentIncidenceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IncidenceCommitment
     */
    'userId'?: string;
}

export const IncidenceCommitmentIncidenceTypeEnum = {
    DeliveryIncidence: 'DELIVERY_INCIDENCE',
    TransportIncidence: 'TRANSPORT_INCIDENCE',
    Lost: 'LOST',
    CollectionIncidence: 'COLLECTION_INCIDENCE',
    CollectionCanceledOrder: 'COLLECTION_CANCELED_ORDER',
    AddressError: 'ADDRESS_ERROR',
    LabelRequestedError: 'LABEL_REQUESTED_ERROR',
    AddressFraudError: 'ADDRESS_FRAUD_ERROR',
    ZipCodeRestricted: 'ZIP_CODE_RESTRICTED'
} as const;

export type IncidenceCommitmentIncidenceTypeEnum = typeof IncidenceCommitmentIncidenceTypeEnum[keyof typeof IncidenceCommitmentIncidenceTypeEnum];

/**
 * 
 * @export
 * @interface Item
 */
export interface Item {
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'size'?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'color'?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'collection'?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'subcategory'?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof Item
     */
    'condition': string;
    /**
     * 
     * @type {ItemPriceComposition}
     * @memberof Item
     */
    'priceComposition': ItemPriceComposition;
    /**
     * 
     * @type {Array<Image>}
     * @memberof Item
     */
    'images': Array<Image>;
}
/**
 * 
 * @export
 * @interface ItemFee
 */
export interface ItemFee {
    /**
     * 
     * @type {string}
     * @memberof ItemFee
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ItemFee
     */
    'type'?: string;
    /**
     * 
     * @type {Amount}
     * @memberof ItemFee
     */
    'amount'?: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof ItemFee
     */
    'taxableAmount'?: Amount;
    /**
     * 
     * @type {Array<Tax>}
     * @memberof ItemFee
     */
    'taxes'?: Array<Tax>;
    /**
     * 
     * @type {string}
     * @memberof ItemFee
     */
    'productClass'?: string;
}
/**
 * 
 * @export
 * @interface ItemPriceComposition
 */
export interface ItemPriceComposition {
    /**
     * 
     * @type {Amount}
     * @memberof ItemPriceComposition
     */
    'baseAmount': Amount;
    /**
     * 
     * @type {boolean}
     * @memberof ItemPriceComposition
     */
    'retailPriceTaxesIncluded': boolean;
    /**
     * 
     * @type {Array<ItemFee>}
     * @memberof ItemPriceComposition
     */
    'fees'?: Array<ItemFee>;
    /**
     * 
     * @type {Array<Tax>}
     * @memberof ItemPriceComposition
     */
    'taxes'?: Array<Tax>;
    /**
     * 
     * @type {ShippingCosts}
     * @memberof ItemPriceComposition
     */
    'shippingCosts'?: ShippingCosts;
    /**
     * 
     * @type {Array<OtherPrice>}
     * @memberof ItemPriceComposition
     */
    'others'?: Array<OtherPrice>;
    /**
     * 
     * @type {Amount}
     * @memberof ItemPriceComposition
     */
    'totalAmount': Amount;
}
/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'streetName'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'streetNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'floor'?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    'door'?: string;
    /**
     * 
     * @type {Coordinates}
     * @memberof Location
     */
    'coordinates'?: Coordinates;
}
/**
 * 
 * @export
 * @interface MilestoneDates
 */
export interface MilestoneDates {
    /**
     * 
     * @type {string}
     * @memberof MilestoneDates
     */
    'placedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDates
     */
    'shippedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDates
     */
    'inTransitAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDates
     */
    'deliveredAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDates
     */
    'paidAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDates
     */
    'billedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneDates
     */
    'cancelledAt'?: string;
}
/**
 * 
 * @export
 * @interface OrderPriceComposition
 */
export interface OrderPriceComposition {
    /**
     * 
     * @type {Amount}
     * @memberof OrderPriceComposition
     */
    'baseAmount': Amount;
    /**
     * 
     * @type {boolean}
     * @memberof OrderPriceComposition
     */
    'retailPriceTaxesIncluded': boolean;
    /**
     * 
     * @type {Array<Fee>}
     * @memberof OrderPriceComposition
     */
    'fees'?: Array<Fee>;
    /**
     * 
     * @type {Array<Tax>}
     * @memberof OrderPriceComposition
     */
    'taxes'?: Array<Tax>;
    /**
     * 
     * @type {ShippingCosts}
     * @memberof OrderPriceComposition
     */
    'shippingCosts'?: ShippingCosts;
    /**
     * 
     * @type {Array<OtherPrice>}
     * @memberof OrderPriceComposition
     */
    'others'?: Array<OtherPrice>;
    /**
     * 
     * @type {Amount}
     * @memberof OrderPriceComposition
     */
    'totalAmount': Amount;
}
/**
 * 
 * @export
 * @interface OtherPrice
 */
export interface OtherPrice {
    /**
     * 
     * @type {string}
     * @memberof OtherPrice
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof OtherPrice
     */
    'type'?: OtherPriceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OtherPrice
     */
    'code'?: string;
    /**
     * 
     * @type {Amount}
     * @memberof OtherPrice
     */
    'amount'?: Amount;
}

export const OtherPriceTypeEnum = {
    Promotion: 'PROMOTION',
    Adjustment: 'ADJUSTMENT',
    Service: 'SERVICE',
    Duty: 'DUTY'
} as const;

export type OtherPriceTypeEnum = typeof OtherPriceTypeEnum[keyof typeof OtherPriceTypeEnum];

/**
 * 
 * @export
 * @interface Payment
 */
export interface Payment {
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'paymentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    'paymentStatus'?: string;
    /**
     * 
     * @type {Amount}
     * @memberof Payment
     */
    'paymentAmount'?: Amount;
}
/**
 * 
 * @export
 * @interface Phone
 */
export interface Phone {
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'number'?: string;
    /**
     * 
     * @type {string}
     * @memberof Phone
     */
    'prefix'?: string;
}
/**
 * 
 * @export
 * @interface PrivacyPolicy
 */
export interface PrivacyPolicy {
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicy
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrivacyPolicy
     */
    'legalText'?: string;
}
/**
 * 
 * @export
 * @interface Rating
 */
export interface Rating {
    /**
     * 
     * @type {number}
     * @memberof Rating
     */
    'rating'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rating
     */
    'productRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rating
     */
    'packagingRating'?: number;
    /**
     * 
     * @type {number}
     * @memberof Rating
     */
    'shippingRating'?: number;
    /**
     * 
     * @type {string}
     * @memberof Rating
     */
    'ratedAt'?: string;
}
/**
 * 
 * @export
 * @interface RejectionCommitment
 */
export interface RejectionCommitment {
    /**
     * 
     * @type {string}
     * @memberof RejectionCommitment
     */
    'rejectedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof RejectionCommitment
     */
    'rejectionReason'?: RejectionCommitmentRejectionReasonEnum;
}

export const RejectionCommitmentRejectionReasonEnum = {
    Incidence: 'INCIDENCE',
    Dispute: 'DISPUTE',
    Lost: 'LOST'
} as const;

export type RejectionCommitmentRejectionReasonEnum = typeof RejectionCommitmentRejectionReasonEnum[keyof typeof RejectionCommitmentRejectionReasonEnum];

/**
 * 
 * @export
 * @interface ResellEventReprocessWithInputError
 */
export interface ResellEventReprocessWithInputError {
    /**
     * 
     * @type {number}
     * @memberof ResellEventReprocessWithInputError
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof ResellEventReprocessWithInputError
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface ResellOrder
 */
export interface ResellOrder {
    /**
     * 
     * @type {string}
     * @memberof ResellOrder
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellOrder
     */
    'groupOrderId': string;
    /**
     * 
     * @type {Store}
     * @memberof ResellOrder
     */
    'store': Store;
    /**
     * 
     * @type {string}
     * @memberof ResellOrder
     */
    'internalStatus'?: ResellOrderInternalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ResellOrder
     */
    'externalStatus'?: ResellOrderExternalStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ResellOrder
     */
    'purchaseLanguage': string;
    /**
     * 
     * @type {Buyer}
     * @memberof ResellOrder
     */
    'buyer': Buyer;
    /**
     * 
     * @type {Seller}
     * @memberof ResellOrder
     */
    'seller': Seller;
    /**
     * 
     * @type {Droppoint}
     * @memberof ResellOrder
     */
    'droppoint'?: Droppoint;
    /**
     * 
     * @type {Tracking}
     * @memberof ResellOrder
     */
    'tracking'?: Tracking;
    /**
     * 
     * @type {OrderPriceComposition}
     * @memberof ResellOrder
     */
    'orderPriceComposition': OrderPriceComposition;
    /**
     * 
     * @type {OrderPriceComposition}
     * @memberof ResellOrder
     */
    'orderOriginalPriceComposition'?: OrderPriceComposition;
    /**
     * 
     * @type {Array<Item>}
     * @memberof ResellOrder
     */
    'items': Array<Item>;
    /**
     * 
     * @type {Rating}
     * @memberof ResellOrder
     */
    'rating'?: Rating;
    /**
     * 
     * @type {boolean}
     * @memberof ResellOrder
     */
    'ratingIgnoringFlag'?: boolean;
    /**
     * 
     * @type {Array<AdditionalReference>}
     * @memberof ResellOrder
     */
    'additionalReferences'?: Array<AdditionalReference>;
    /**
     * 
     * @type {boolean}
     * @memberof ResellOrder
     */
    'sellerPayout'?: boolean;
    /**
     * 
     * @type {MilestoneDates}
     * @memberof ResellOrder
     */
    'milestoneDates'?: MilestoneDates;
    /**
     * 
     * @type {DeliveryCommitment}
     * @memberof ResellOrder
     */
    'delivery'?: DeliveryCommitment;
    /**
     * 
     * @type {BillingCommitment}
     * @memberof ResellOrder
     */
    'billing'?: BillingCommitment;
    /**
     * 
     * @type {boolean}
     * @memberof ResellOrder
     */
    'sellerStripeAccountEnabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ResellOrder
     */
    'comment'?: string;
    /**
     * 
     * @type {DisputeCommitment}
     * @memberof ResellOrder
     */
    'dispute'?: DisputeCommitment;
    /**
     * 
     * @type {IncidenceCommitment}
     * @memberof ResellOrder
     */
    'incidence'?: IncidenceCommitment;
    /**
     * 
     * @type {RejectionCommitment}
     * @memberof ResellOrder
     */
    'rejection'?: RejectionCommitment;
    /**
     * 
     * @type {AcceptanceCommitment}
     * @memberof ResellOrder
     */
    'acceptance'?: AcceptanceCommitment;
    /**
     * 
     * @type {CancellationCommitment}
     * @memberof ResellOrder
     */
    'cancellation'?: CancellationCommitment;
    /**
     * 
     * @type {boolean}
     * @memberof ResellOrder
     */
    'isMigrated'?: boolean;
}

export const ResellOrderInternalStatusEnum = {
    AttemptedDelivery: 'ATTEMPTED_DELIVERY',
    DeliveryIncidence: 'DELIVERY_INCIDENCE',
    InDelivery: 'IN_DELIVERY',
    LabelRequested: 'LABEL_REQUESTED',
    LabelReceived: 'LABEL_RECEIVED',
    Lost: 'LOST',
    PickupIncidence: 'PICKUP_INCIDENCE',
    ShippingIncidence: 'SHIPPING_INCIDENCE',
    UpdateProposal: 'UPDATE_PROPOSAL'
} as const;

export type ResellOrderInternalStatusEnum = typeof ResellOrderInternalStatusEnum[keyof typeof ResellOrderInternalStatusEnum];
export const ResellOrderExternalStatusEnum = {
    Accepted: 'ACCEPTED',
    Cancelled: 'CANCELLED',
    Created: 'CREATED',
    Delivered: 'DELIVERED',
    InDispute: 'IN_DISPUTE',
    InTransit: 'IN_TRANSIT',
    InDropPoint: 'IN_DROP_POINT',
    Incidence: 'INCIDENCE',
    Received: 'RECEIVED',
    Rejected: 'REJECTED',
    Shipped: 'SHIPPED',
    Temp: 'TEMP',
    Lost: 'LOST'
} as const;

export type ResellOrderExternalStatusEnum = typeof ResellOrderExternalStatusEnum[keyof typeof ResellOrderExternalStatusEnum];

/**
 * 
 * @export
 * @interface ResellOrderAcceptDispute
 */
export interface ResellOrderAcceptDispute {
    /**
     * 
     * @type {string}
     * @memberof ResellOrderAcceptDispute
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellOrderAcceptDispute
     */
    'disputeResolutionCommentary'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellOrderAcceptDispute
     */
    'callAgent'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResellOrderAcceptDispute
     */
    'disputeItems'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResellOrderCommentary
 */
export interface ResellOrderCommentary {
    /**
     * 
     * @type {string}
     * @memberof ResellOrderCommentary
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellOrderCommentary
     */
    'commentary'?: string;
}
/**
 * 
 * @export
 * @interface ResellOrderRejectDispute
 */
export interface ResellOrderRejectDispute {
    /**
     * 
     * @type {string}
     * @memberof ResellOrderRejectDispute
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellOrderRejectDispute
     */
    'disputeResolutionCommentary'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellOrderRejectDispute
     */
    'callAgent'?: string;
}
/**
 * 
 * @export
 * @interface RestrictedInfo
 */
export interface RestrictedInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof RestrictedInfo
     */
    'zipCodesRestricted'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof RestrictedInfo
     */
    'statesRestricted'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RestrictedResult
 */
export interface RestrictedResult {
    /**
     * 
     * @type {number}
     * @memberof RestrictedResult
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof RestrictedResult
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface Seller
 */
export interface Seller {
    /**
     * 
     * @type {string}
     * @memberof Seller
     */
    'sellerExternalId'?: string;
    /**
     * 
     * @type {Address}
     * @memberof Seller
     */
    'address'?: Address;
}
/**
 * 
 * @export
 * @interface ShippingCosts
 */
export interface ShippingCosts {
    /**
     * 
     * @type {Amount}
     * @memberof ShippingCosts
     */
    'amount'?: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof ShippingCosts
     */
    'taxesAmount'?: Amount;
}
/**
 * 
 * @export
 * @interface StandarizedGeopoliticalSubdivision
 */
export interface StandarizedGeopoliticalSubdivision {
    /**
     * 
     * @type {string}
     * @memberof StandarizedGeopoliticalSubdivision
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StandarizedGeopoliticalSubdivision
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface StateMachineData
 */
export interface StateMachineData {
    /**
     * 
     * @type {string}
     * @memberof StateMachineData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof StateMachineData
     */
    'type'?: StateMachineDataTypeEnum;
    /**
     * 
     * @type {Array<StateMachineEvent>}
     * @memberof StateMachineData
     */
    'states'?: Array<StateMachineEvent>;
}

export const StateMachineDataTypeEnum = {
    OrderMachine: 'ORDER-MACHINE',
    SubOrderMachine: 'SUB-ORDER-MACHINE'
} as const;

export type StateMachineDataTypeEnum = typeof StateMachineDataTypeEnum[keyof typeof StateMachineDataTypeEnum];

/**
 * 
 * @export
 * @interface StateMachineEvent
 */
export interface StateMachineEvent {
    /**
     * 
     * @type {string}
     * @memberof StateMachineEvent
     */
    'statusCommerce'?: StateMachineEventStatusCommerceEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof StateMachineEvent
     */
    'eventTypeList'?: Array<StateMachineEventEventTypeListEnum>;
}

export const StateMachineEventStatusCommerceEnum = {
    Created: 'CREATED',
    Shipping: 'SHIPPING',
    Delivered: 'DELIVERED',
    Canceled: 'CANCELED',
    Acepted: 'ACEPTED',
    Dispute: 'DISPUTE'
} as const;

export type StateMachineEventStatusCommerceEnum = typeof StateMachineEventStatusCommerceEnum[keyof typeof StateMachineEventStatusCommerceEnum];
export const StateMachineEventEventTypeListEnum = {
    AcceptedStatus: 'ACCEPTED_STATUS',
    CancelledStatus: 'CANCELLED_STATUS',
    CreatedStatus: 'CREATED_STATUS',
    DeliveredStatus: 'DELIVERED_STATUS',
    InDisputeStatus: 'IN_DISPUTE_STATUS',
    InTransitStatus: 'IN_TRANSIT_STATUS',
    InDropPointStatus: 'IN_DROP_POINT_STATUS',
    IncidenceStatus: 'INCIDENCE_STATUS',
    ReceivedStatus: 'RECEIVED_STATUS',
    RejectedStatus: 'REJECTED_STATUS',
    ShippedStatus: 'SHIPPED_STATUS',
    LabelReceived: 'LABEL_RECEIVED',
    LabelRequested: 'LABEL_REQUESTED',
    EmailSend: 'EMAIL_SEND',
    RememberEvent: 'REMEMBER_EVENT',
    LostStatus: 'LOST_STATUS',
    AddressModify: 'ADDRESS_MODIFY',
    RegeneratedLabel: 'REGENERATED_LABEL',
    AcceptDispute: 'ACCEPT_DISPUTE',
    RejectDispute: 'REJECT_DISPUTE',
    UpdateTracking: 'UPDATE_TRACKING',
    PostDisputeResolution: 'POST_DISPUTE_RESOLUTION',
    ManualCancellation: 'MANUAL_CANCELLATION',
    PostCommentary: 'POST_COMMENTARY'
} as const;

export type StateMachineEventEventTypeListEnum = typeof StateMachineEventEventTypeListEnum[keyof typeof StateMachineEventEventTypeListEnum];

/**
 * 
 * @export
 * @interface StatusHistoryItem
 */
export interface StatusHistoryItem {
    /**
     * 
     * @type {string}
     * @memberof StatusHistoryItem
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof StatusHistoryItem
     */
    'event': string;
}
/**
 * 
 * @export
 * @interface Store
 */
export interface Store {
    /**
     * 
     * @type {number}
     * @memberof Store
     */
    'storeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Store
     */
    'storeName'?: string;
    /**
     * 
     * @type {number}
     * @memberof Store
     */
    'brandId'?: number;
}
/**
 * 
 * @export
 * @interface Tax
 */
export interface Tax {
    /**
     * 
     * @type {string}
     * @memberof Tax
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Tax
     */
    'code'?: string;
    /**
     * 
     * @type {number}
     * @memberof Tax
     */
    'rate'?: number;
    /**
     * 
     * @type {Amount}
     * @memberof Tax
     */
    'amount'?: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof Tax
     */
    'basis'?: Amount;
}
/**
 * 
 * @export
 * @interface Tracking
 */
export interface Tracking {
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    'trackingNumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof Tracking
     */
    'courierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Tracking
     */
    'trackingUrl'?: string;
}
/**
 * 
 * @export
 * @interface TrackingUpdateProposal
 */
export interface TrackingUpdateProposal {
    /**
     * 
     * @type {string}
     * @memberof TrackingUpdateProposal
     */
    'orderId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingUpdateProposal
     */
    'status'?: TrackingUpdateProposalStatusEnum;
}

export const TrackingUpdateProposalStatusEnum = {
    Created: 'CREATED',
    Shipped: 'SHIPPED',
    InTransit: 'IN_TRANSIT',
    InDropPoint: 'IN_DROP_POINT',
    Delivered: 'DELIVERED',
    Cancelled: 'CANCELLED',
    Accepted: 'ACCEPTED',
    InDispute: 'IN_DISPUTE',
    Rejected: 'REJECTED',
    Incidence: 'INCIDENCE',
    Lost: 'LOST'
} as const;

export type TrackingUpdateProposalStatusEnum = typeof TrackingUpdateProposalStatusEnum[keyof typeof TrackingUpdateProposalStatusEnum];

/**
 * 
 * @export
 * @interface UpdateResellOrder
 */
export interface UpdateResellOrder {
    /**
     * 
     * @type {string}
     * @memberof UpdateResellOrder
     */
    'eventTrigger'?: UpdateResellOrderEventTriggerEnum;
    /**
     * 
     * @type {ResellOrder}
     * @memberof UpdateResellOrder
     */
    'resellOrder'?: ResellOrder;
}

export const UpdateResellOrderEventTriggerEnum = {
    Shipment: 'SHIPMENT',
    Delivery: 'DELIVERY',
    Dispute: 'DISPUTE',
    BuyerCancelation: 'BUYER_CANCELATION',
    SellerCancelation: 'SELLER_CANCELATION',
    Rejection: 'REJECTION',
    ForcedUpdate: 'FORCED_UPDATE'
} as const;

export type UpdateResellOrderEventTriggerEnum = typeof UpdateResellOrderEventTriggerEnum[keyof typeof UpdateResellOrderEventTriggerEnum];


/**
 * AdminMachineApi - axios parameter creator
 * @export
 */
export const AdminMachineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get All State machines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStateMachines: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/admin/stateMachine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary retrieve a state machine
         * @param {string} stateMachineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateMachineId: async (stateMachineId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateMachineId' is not null or undefined
            assertParamExists('getStateMachineId', 'stateMachineId', stateMachineId)
            const localVarPath = `/itxrest/4/private/resell/admin/stateMachine/{stateMachineId}`
                .replace(`{${"stateMachineId"}}`, encodeURIComponent(String(stateMachineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a state machine
         * @param {string} stateMachineId 
         * @param {StateMachineData} [stateMachineData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStateMachineId: async (stateMachineId: string, stateMachineData?: StateMachineData, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stateMachineId' is not null or undefined
            assertParamExists('patchStateMachineId', 'stateMachineId', stateMachineId)
            const localVarPath = `/itxrest/4/private/resell/admin/stateMachine/{stateMachineId}`
                .replace(`{${"stateMachineId"}}`, encodeURIComponent(String(stateMachineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stateMachineData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a state machine
         * @param {StateMachineData} [stateMachineData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStateMachine: async (stateMachineData?: StateMachineData, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/admin/stateMachine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(stateMachineData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminMachineApi - functional programming interface
 * @export
 */
export const AdminMachineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminMachineApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get All State machines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllStateMachines(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StateMachineData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllStateMachines(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary retrieve a state machine
         * @param {string} stateMachineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStateMachineId(stateMachineId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateMachineData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStateMachineId(stateMachineId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a state machine
         * @param {string} stateMachineId 
         * @param {StateMachineData} [stateMachineData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchStateMachineId(stateMachineId: string, stateMachineData?: StateMachineData, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateMachineData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchStateMachineId(stateMachineId, stateMachineData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a state machine
         * @param {StateMachineData} [stateMachineData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postStateMachine(stateMachineData?: StateMachineData, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateMachineData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postStateMachine(stateMachineData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminMachineApi - factory interface
 * @export
 */
export const AdminMachineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminMachineApiFp(configuration)
    return {
        /**
         * 
         * @summary Get All State machines
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStateMachines(options?: any): AxiosPromise<Array<StateMachineData>> {
            return localVarFp.getAllStateMachines(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary retrieve a state machine
         * @param {string} stateMachineId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateMachineId(stateMachineId: string, options?: any): AxiosPromise<StateMachineData> {
            return localVarFp.getStateMachineId(stateMachineId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a state machine
         * @param {string} stateMachineId 
         * @param {StateMachineData} [stateMachineData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchStateMachineId(stateMachineId: string, stateMachineData?: StateMachineData, options?: any): AxiosPromise<StateMachineData> {
            return localVarFp.patchStateMachineId(stateMachineId, stateMachineData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a state machine
         * @param {StateMachineData} [stateMachineData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postStateMachine(stateMachineData?: StateMachineData, options?: any): AxiosPromise<StateMachineData> {
            return localVarFp.postStateMachine(stateMachineData, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminMachineApi - interface
 * @export
 * @interface AdminMachineApi
 */
export interface AdminMachineApiInterface {
    /**
     * 
     * @summary Get All State machines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMachineApiInterface
     */
    getAllStateMachines(options?: AxiosRequestConfig): AxiosPromise<Array<StateMachineData>>;

    /**
     * 
     * @summary retrieve a state machine
     * @param {string} stateMachineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMachineApiInterface
     */
    getStateMachineId(stateMachineId: string, options?: AxiosRequestConfig): AxiosPromise<StateMachineData>;

    /**
     * 
     * @summary Update a state machine
     * @param {string} stateMachineId 
     * @param {StateMachineData} [stateMachineData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMachineApiInterface
     */
    patchStateMachineId(stateMachineId: string, stateMachineData?: StateMachineData, options?: AxiosRequestConfig): AxiosPromise<StateMachineData>;

    /**
     * 
     * @summary Create a state machine
     * @param {StateMachineData} [stateMachineData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMachineApiInterface
     */
    postStateMachine(stateMachineData?: StateMachineData, options?: AxiosRequestConfig): AxiosPromise<StateMachineData>;

}

/**
 * AdminMachineApi - object-oriented interface
 * @export
 * @class AdminMachineApi
 * @extends {BaseAPI}
 */
export class AdminMachineApi extends BaseAPI implements AdminMachineApiInterface {
    /**
     * 
     * @summary Get All State machines
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMachineApi
     */
    public getAllStateMachines(options?: AxiosRequestConfig) {
        return AdminMachineApiFp(this.configuration).getAllStateMachines(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary retrieve a state machine
     * @param {string} stateMachineId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMachineApi
     */
    public getStateMachineId(stateMachineId: string, options?: AxiosRequestConfig) {
        return AdminMachineApiFp(this.configuration).getStateMachineId(stateMachineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a state machine
     * @param {string} stateMachineId 
     * @param {StateMachineData} [stateMachineData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMachineApi
     */
    public patchStateMachineId(stateMachineId: string, stateMachineData?: StateMachineData, options?: AxiosRequestConfig) {
        return AdminMachineApiFp(this.configuration).patchStateMachineId(stateMachineId, stateMachineData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a state machine
     * @param {StateMachineData} [stateMachineData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminMachineApi
     */
    public postStateMachine(stateMachineData?: StateMachineData, options?: AxiosRequestConfig) {
        return AdminMachineApiFp(this.configuration).postStateMachine(stateMachineData, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PrivacyPolicyApi - axios parameter creator
 * @export
 */
export const PrivacyPolicyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete a privacy policy
         * @summary Delete a privacy policy
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrivacyPolicy: async (locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('deletePrivacyPolicy', 'locale', locale)
            const localVarPath = `/itxrest/4/private/resell/external/privacy-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get legal info by country and language
         * @param {string} countryCode 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicy: async (countryCode: string, language?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getPrivacyPolicy', 'countryCode', countryCode)
            const localVarPath = `/itxrest/4/private/resell/external/privacy-policy/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a new privacy policy
         * @summary Add a new privacy policy
         * @param {PrivacyPolicy} [privacyPolicy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPrivacyPolicy: async (privacyPolicy?: PrivacyPolicy, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/external/privacy-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(privacyPolicy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify a new privacy policy
         * @summary Modify a new privacy policy
         * @param {PrivacyPolicy} [privacyPolicy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPrivacyPolicy: async (privacyPolicy?: PrivacyPolicy, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/external/privacy-policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(privacyPolicy, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PrivacyPolicyApi - functional programming interface
 * @export
 */
export const PrivacyPolicyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PrivacyPolicyApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete a privacy policy
         * @summary Delete a privacy policy
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePrivacyPolicy(locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePrivacyPolicy(locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get legal info by country and language
         * @param {string} countryCode 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivacyPolicy(countryCode: string, language?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrivacyPolicy>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivacyPolicy(countryCode, language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add a new privacy policy
         * @summary Add a new privacy policy
         * @param {PrivacyPolicy} [privacyPolicy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postPrivacyPolicy(privacyPolicy?: PrivacyPolicy, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postPrivacyPolicy(privacyPolicy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Modify a new privacy policy
         * @summary Modify a new privacy policy
         * @param {PrivacyPolicy} [privacyPolicy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putPrivacyPolicy(privacyPolicy?: PrivacyPolicy, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putPrivacyPolicy(privacyPolicy, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PrivacyPolicyApi - factory interface
 * @export
 */
export const PrivacyPolicyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PrivacyPolicyApiFp(configuration)
    return {
        /**
         * Delete a privacy policy
         * @summary Delete a privacy policy
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePrivacyPolicy(locale: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePrivacyPolicy(locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get legal info by country and language
         * @param {string} countryCode 
         * @param {string} [language] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacyPolicy(countryCode: string, language?: string, options?: any): AxiosPromise<PrivacyPolicy> {
            return localVarFp.getPrivacyPolicy(countryCode, language, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a new privacy policy
         * @summary Add a new privacy policy
         * @param {PrivacyPolicy} [privacyPolicy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPrivacyPolicy(privacyPolicy?: PrivacyPolicy, options?: any): AxiosPromise<void> {
            return localVarFp.postPrivacyPolicy(privacyPolicy, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify a new privacy policy
         * @summary Modify a new privacy policy
         * @param {PrivacyPolicy} [privacyPolicy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putPrivacyPolicy(privacyPolicy?: PrivacyPolicy, options?: any): AxiosPromise<void> {
            return localVarFp.putPrivacyPolicy(privacyPolicy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PrivacyPolicyApi - interface
 * @export
 * @interface PrivacyPolicyApi
 */
export interface PrivacyPolicyApiInterface {
    /**
     * Delete a privacy policy
     * @summary Delete a privacy policy
     * @param {string} locale 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApiInterface
     */
    deletePrivacyPolicy(locale: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get legal info by country and language
     * @param {string} countryCode 
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApiInterface
     */
    getPrivacyPolicy(countryCode: string, language?: string, options?: AxiosRequestConfig): AxiosPromise<PrivacyPolicy>;

    /**
     * Add a new privacy policy
     * @summary Add a new privacy policy
     * @param {PrivacyPolicy} [privacyPolicy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApiInterface
     */
    postPrivacyPolicy(privacyPolicy?: PrivacyPolicy, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Modify a new privacy policy
     * @summary Modify a new privacy policy
     * @param {PrivacyPolicy} [privacyPolicy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApiInterface
     */
    putPrivacyPolicy(privacyPolicy?: PrivacyPolicy, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * PrivacyPolicyApi - object-oriented interface
 * @export
 * @class PrivacyPolicyApi
 * @extends {BaseAPI}
 */
export class PrivacyPolicyApi extends BaseAPI implements PrivacyPolicyApiInterface {
    /**
     * Delete a privacy policy
     * @summary Delete a privacy policy
     * @param {string} locale 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApi
     */
    public deletePrivacyPolicy(locale: string, options?: AxiosRequestConfig) {
        return PrivacyPolicyApiFp(this.configuration).deletePrivacyPolicy(locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get legal info by country and language
     * @param {string} countryCode 
     * @param {string} [language] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApi
     */
    public getPrivacyPolicy(countryCode: string, language?: string, options?: AxiosRequestConfig) {
        return PrivacyPolicyApiFp(this.configuration).getPrivacyPolicy(countryCode, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a new privacy policy
     * @summary Add a new privacy policy
     * @param {PrivacyPolicy} [privacyPolicy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApi
     */
    public postPrivacyPolicy(privacyPolicy?: PrivacyPolicy, options?: AxiosRequestConfig) {
        return PrivacyPolicyApiFp(this.configuration).postPrivacyPolicy(privacyPolicy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modify a new privacy policy
     * @summary Modify a new privacy policy
     * @param {PrivacyPolicy} [privacyPolicy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivacyPolicyApi
     */
    public putPrivacyPolicy(privacyPolicy?: PrivacyPolicy, options?: AxiosRequestConfig) {
        return PrivacyPolicyApiFp(this.configuration).putPrivacyPolicy(privacyPolicy, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellAftersalesQueryServiceApi - axios parameter creator
 * @export
 */
export const ResellAftersalesQueryServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary manual cancel order
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (storeId: number, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('cancelOrder', 'storeId', storeId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancelOrder', 'orderId', orderId)
            const localVarPath = `/itxrest/4/resell/store/{storeId}/cancel-order/{orderId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a full detail of a resell order, including: Order and line statuses and contents, Order amounts (base, fees, duty, shipping costs, services, totals), Buyer and Seller contact information, Milestones, Tracking information. 
         * @summary Get resell order detail
         * @param {number} storeId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrder: async (storeId: number, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getResellOrder', 'storeId', storeId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getResellOrder', 'id', id)
            const localVarPath = `/itxrest/4/private/resell/2/external/store/{storeId}/order/{id}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the status history of a resell order. 
         * @summary Get resell order status history
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrderStatusHistory: async (storeId: number, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getResellOrderStatusHistory', 'storeId', storeId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getResellOrderStatusHistory', 'orderId', orderId)
            const localVarPath = `/itxrest/4/private/resell/2/external/store/{storeId}/order/{orderId}/statusHistory`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a PDF containing tracking label
         * @summary Get resell order tracking label
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrderTrackingLabel: async (storeId: number, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getResellOrderTrackingLabel', 'storeId', storeId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getResellOrderTrackingLabel', 'orderId', orderId)
            const localVarPath = `/itxrest/4/private/resell/2/external/store/{storeId}/order/{orderId}/tracking/label`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filtered resell order count
         * @param {string} [orderId] Order id
         * @param {string} [status] Order status
         * @param {string} [reason] Incidence reason
         * @param {string} [buyerEmail] Buyer\&#39;s email
         * @param {string} [buyerName] Buyer\&#39;s name
         * @param {string} [buyerSurname] Buyer\&#39;s surname
         * @param {string} [sellerEmail] Seller\&#39;s email
         * @param {string} [sellerName] Seller\&#39;s name
         * @param {string} [sellerSurname] Seller\&#39;s surname
         * @param {string} [commentary] Order\&#39;s commentary
         * @param {string} [start] Start creation date
         * @param {string} [end] End creation date
         * @param {string} [disputeStatus] Dispute status
         * @param {string} [groupOrderId] Order group id
         * @param {Array<string>} [countries] Countries codes
         * @param {Array<number>} [storeIds] Store ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrdersCount: async (orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/2/external/order/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }

            if (buyerEmail !== undefined) {
                localVarQueryParameter['buyerEmail'] = buyerEmail;
            }

            if (buyerName !== undefined) {
                localVarQueryParameter['buyerName'] = buyerName;
            }

            if (buyerSurname !== undefined) {
                localVarQueryParameter['buyerSurname'] = buyerSurname;
            }

            if (sellerEmail !== undefined) {
                localVarQueryParameter['sellerEmail'] = sellerEmail;
            }

            if (sellerName !== undefined) {
                localVarQueryParameter['sellerName'] = sellerName;
            }

            if (sellerSurname !== undefined) {
                localVarQueryParameter['sellerSurname'] = sellerSurname;
            }

            if (commentary !== undefined) {
                localVarQueryParameter['commentary'] = commentary;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (disputeStatus !== undefined) {
                localVarQueryParameter['disputeStatus'] = disputeStatus;
            }

            if (groupOrderId !== undefined) {
                localVarQueryParameter['groupOrderId'] = groupOrderId;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get filtered resell order list
         * @param {number} [page] Page number from which to start retrieving rules
         * @param {number} [size] Number of rules displayed per page
         * @param {string} [orderId] Order id
         * @param {string} [status] Order status
         * @param {string} [reason] Incidence reason
         * @param {string} [buyerEmail] Buyer\&#39;s email
         * @param {string} [buyerName] Buyer\&#39;s name
         * @param {string} [buyerSurname] Buyer\&#39;s surname
         * @param {string} [sellerEmail] Seller\&#39;s email
         * @param {string} [sellerName] Seller\&#39;s name
         * @param {string} [sellerSurname] Seller\&#39;s surname
         * @param {string} [commentary] Order\&#39;s commentary
         * @param {string} [start] Start creation date
         * @param {string} [end] End creation date
         * @param {string} [disputeStatus] Dispute status
         * @param {string} [groupOrderId] Order group id
         * @param {Array<string>} [countries] countries codes
         * @param {Array<number>} [storeIds] Store ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrdersFiltered: async (page?: number, size?: number, orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/2/external/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }

            if (buyerEmail !== undefined) {
                localVarQueryParameter['buyerEmail'] = buyerEmail;
            }

            if (buyerName !== undefined) {
                localVarQueryParameter['buyerName'] = buyerName;
            }

            if (buyerSurname !== undefined) {
                localVarQueryParameter['buyerSurname'] = buyerSurname;
            }

            if (sellerEmail !== undefined) {
                localVarQueryParameter['sellerEmail'] = sellerEmail;
            }

            if (sellerName !== undefined) {
                localVarQueryParameter['sellerName'] = sellerName;
            }

            if (sellerSurname !== undefined) {
                localVarQueryParameter['sellerSurname'] = sellerSurname;
            }

            if (commentary !== undefined) {
                localVarQueryParameter['commentary'] = commentary;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }

            if (disputeStatus !== undefined) {
                localVarQueryParameter['disputeStatus'] = disputeStatus;
            }

            if (groupOrderId !== undefined) {
                localVarQueryParameter['groupOrderId'] = groupOrderId;
            }

            if (countries) {
                localVarQueryParameter['countries'] = countries;
            }

            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Regenerate resell order tracking label
         * @summary Regenerate resell order tracking label
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateResellOrderTrackingLabel: async (storeId: number, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('regenerateResellOrderTrackingLabel', 'storeId', storeId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('regenerateResellOrderTrackingLabel', 'orderId', orderId)
            const localVarPath = `/itxrest/4/private/resell/2/external/store/{storeId}/order/{orderId}/tracking/label/regenerate`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellAftersalesQueryServiceApi - functional programming interface
 * @export
 */
export const ResellAftersalesQueryServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellAftersalesQueryServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary manual cancel order
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(storeId: number, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(storeId, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a full detail of a resell order, including: Order and line statuses and contents, Order amounts (base, fees, duty, shipping costs, services, totals), Buyer and Seller contact information, Milestones, Tracking information. 
         * @summary Get resell order detail
         * @param {number} storeId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellOrder(storeId: number, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellOrder(storeId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the status history of a resell order. 
         * @summary Get resell order status history
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellOrderStatusHistory(storeId: number, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StatusHistoryItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellOrderStatusHistory(storeId, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a PDF containing tracking label
         * @summary Get resell order tracking label
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellOrderTrackingLabel(storeId: number, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellOrderTrackingLabel(storeId, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get filtered resell order count
         * @param {string} [orderId] Order id
         * @param {string} [status] Order status
         * @param {string} [reason] Incidence reason
         * @param {string} [buyerEmail] Buyer\&#39;s email
         * @param {string} [buyerName] Buyer\&#39;s name
         * @param {string} [buyerSurname] Buyer\&#39;s surname
         * @param {string} [sellerEmail] Seller\&#39;s email
         * @param {string} [sellerName] Seller\&#39;s name
         * @param {string} [sellerSurname] Seller\&#39;s surname
         * @param {string} [commentary] Order\&#39;s commentary
         * @param {string} [start] Start creation date
         * @param {string} [end] End creation date
         * @param {string} [disputeStatus] Dispute status
         * @param {string} [groupOrderId] Order group id
         * @param {Array<string>} [countries] Countries codes
         * @param {Array<number>} [storeIds] Store ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellOrdersCount(orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellOrdersCount(orderId, status, reason, buyerEmail, buyerName, buyerSurname, sellerEmail, sellerName, sellerSurname, commentary, start, end, disputeStatus, groupOrderId, countries, storeIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get filtered resell order list
         * @param {number} [page] Page number from which to start retrieving rules
         * @param {number} [size] Number of rules displayed per page
         * @param {string} [orderId] Order id
         * @param {string} [status] Order status
         * @param {string} [reason] Incidence reason
         * @param {string} [buyerEmail] Buyer\&#39;s email
         * @param {string} [buyerName] Buyer\&#39;s name
         * @param {string} [buyerSurname] Buyer\&#39;s surname
         * @param {string} [sellerEmail] Seller\&#39;s email
         * @param {string} [sellerName] Seller\&#39;s name
         * @param {string} [sellerSurname] Seller\&#39;s surname
         * @param {string} [commentary] Order\&#39;s commentary
         * @param {string} [start] Start creation date
         * @param {string} [end] End creation date
         * @param {string} [disputeStatus] Dispute status
         * @param {string} [groupOrderId] Order group id
         * @param {Array<string>} [countries] countries codes
         * @param {Array<number>} [storeIds] Store ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getResellOrdersFiltered(page?: number, size?: number, orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResellOrder>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getResellOrdersFiltered(page, size, orderId, status, reason, buyerEmail, buyerName, buyerSurname, sellerEmail, sellerName, sellerSurname, commentary, start, end, disputeStatus, groupOrderId, countries, storeIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Regenerate resell order tracking label
         * @summary Regenerate resell order tracking label
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regenerateResellOrderTrackingLabel(storeId: number, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regenerateResellOrderTrackingLabel(storeId, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellAftersalesQueryServiceApi - factory interface
 * @export
 */
export const ResellAftersalesQueryServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellAftersalesQueryServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary manual cancel order
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(storeId: number, orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancelOrder(storeId, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a full detail of a resell order, including: Order and line statuses and contents, Order amounts (base, fees, duty, shipping costs, services, totals), Buyer and Seller contact information, Milestones, Tracking information. 
         * @summary Get resell order detail
         * @param {number} storeId 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrder(storeId: number, id: string, options?: any): AxiosPromise<ResellOrder> {
            return localVarFp.getResellOrder(storeId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the status history of a resell order. 
         * @summary Get resell order status history
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrderStatusHistory(storeId: number, orderId: string, options?: any): AxiosPromise<Array<StatusHistoryItem>> {
            return localVarFp.getResellOrderStatusHistory(storeId, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a PDF containing tracking label
         * @summary Get resell order tracking label
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrderTrackingLabel(storeId: number, orderId: string, options?: any): AxiosPromise<string> {
            return localVarFp.getResellOrderTrackingLabel(storeId, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filtered resell order count
         * @param {string} [orderId] Order id
         * @param {string} [status] Order status
         * @param {string} [reason] Incidence reason
         * @param {string} [buyerEmail] Buyer\&#39;s email
         * @param {string} [buyerName] Buyer\&#39;s name
         * @param {string} [buyerSurname] Buyer\&#39;s surname
         * @param {string} [sellerEmail] Seller\&#39;s email
         * @param {string} [sellerName] Seller\&#39;s name
         * @param {string} [sellerSurname] Seller\&#39;s surname
         * @param {string} [commentary] Order\&#39;s commentary
         * @param {string} [start] Start creation date
         * @param {string} [end] End creation date
         * @param {string} [disputeStatus] Dispute status
         * @param {string} [groupOrderId] Order group id
         * @param {Array<string>} [countries] Countries codes
         * @param {Array<number>} [storeIds] Store ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrdersCount(orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options?: any): AxiosPromise<number> {
            return localVarFp.getResellOrdersCount(orderId, status, reason, buyerEmail, buyerName, buyerSurname, sellerEmail, sellerName, sellerSurname, commentary, start, end, disputeStatus, groupOrderId, countries, storeIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get filtered resell order list
         * @param {number} [page] Page number from which to start retrieving rules
         * @param {number} [size] Number of rules displayed per page
         * @param {string} [orderId] Order id
         * @param {string} [status] Order status
         * @param {string} [reason] Incidence reason
         * @param {string} [buyerEmail] Buyer\&#39;s email
         * @param {string} [buyerName] Buyer\&#39;s name
         * @param {string} [buyerSurname] Buyer\&#39;s surname
         * @param {string} [sellerEmail] Seller\&#39;s email
         * @param {string} [sellerName] Seller\&#39;s name
         * @param {string} [sellerSurname] Seller\&#39;s surname
         * @param {string} [commentary] Order\&#39;s commentary
         * @param {string} [start] Start creation date
         * @param {string} [end] End creation date
         * @param {string} [disputeStatus] Dispute status
         * @param {string} [groupOrderId] Order group id
         * @param {Array<string>} [countries] countries codes
         * @param {Array<number>} [storeIds] Store ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellOrdersFiltered(page?: number, size?: number, orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options?: any): AxiosPromise<Array<ResellOrder>> {
            return localVarFp.getResellOrdersFiltered(page, size, orderId, status, reason, buyerEmail, buyerName, buyerSurname, sellerEmail, sellerName, sellerSurname, commentary, start, end, disputeStatus, groupOrderId, countries, storeIds, options).then((request) => request(axios, basePath));
        },
        /**
         * Regenerate resell order tracking label
         * @summary Regenerate resell order tracking label
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regenerateResellOrderTrackingLabel(storeId: number, orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.regenerateResellOrderTrackingLabel(storeId, orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellAftersalesQueryServiceApi - interface
 * @export
 * @interface ResellAftersalesQueryServiceApi
 */
export interface ResellAftersalesQueryServiceApiInterface {
    /**
     * 
     * @summary manual cancel order
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApiInterface
     */
    cancelOrder(storeId: number, orderId: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns a full detail of a resell order, including: Order and line statuses and contents, Order amounts (base, fees, duty, shipping costs, services, totals), Buyer and Seller contact information, Milestones, Tracking information. 
     * @summary Get resell order detail
     * @param {number} storeId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApiInterface
     */
    getResellOrder(storeId: number, id: string, options?: AxiosRequestConfig): AxiosPromise<ResellOrder>;

    /**
     * Returns the status history of a resell order. 
     * @summary Get resell order status history
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApiInterface
     */
    getResellOrderStatusHistory(storeId: number, orderId: string, options?: AxiosRequestConfig): AxiosPromise<Array<StatusHistoryItem>>;

    /**
     * Returns a PDF containing tracking label
     * @summary Get resell order tracking label
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApiInterface
     */
    getResellOrderTrackingLabel(storeId: number, orderId: string, options?: AxiosRequestConfig): AxiosPromise<string>;

    /**
     * 
     * @summary Get filtered resell order count
     * @param {string} [orderId] Order id
     * @param {string} [status] Order status
     * @param {string} [reason] Incidence reason
     * @param {string} [buyerEmail] Buyer\&#39;s email
     * @param {string} [buyerName] Buyer\&#39;s name
     * @param {string} [buyerSurname] Buyer\&#39;s surname
     * @param {string} [sellerEmail] Seller\&#39;s email
     * @param {string} [sellerName] Seller\&#39;s name
     * @param {string} [sellerSurname] Seller\&#39;s surname
     * @param {string} [commentary] Order\&#39;s commentary
     * @param {string} [start] Start creation date
     * @param {string} [end] End creation date
     * @param {string} [disputeStatus] Dispute status
     * @param {string} [groupOrderId] Order group id
     * @param {Array<string>} [countries] Countries codes
     * @param {Array<number>} [storeIds] Store ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApiInterface
     */
    getResellOrdersCount(orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<number>;

    /**
     * 
     * @summary Get filtered resell order list
     * @param {number} [page] Page number from which to start retrieving rules
     * @param {number} [size] Number of rules displayed per page
     * @param {string} [orderId] Order id
     * @param {string} [status] Order status
     * @param {string} [reason] Incidence reason
     * @param {string} [buyerEmail] Buyer\&#39;s email
     * @param {string} [buyerName] Buyer\&#39;s name
     * @param {string} [buyerSurname] Buyer\&#39;s surname
     * @param {string} [sellerEmail] Seller\&#39;s email
     * @param {string} [sellerName] Seller\&#39;s name
     * @param {string} [sellerSurname] Seller\&#39;s surname
     * @param {string} [commentary] Order\&#39;s commentary
     * @param {string} [start] Start creation date
     * @param {string} [end] End creation date
     * @param {string} [disputeStatus] Dispute status
     * @param {string} [groupOrderId] Order group id
     * @param {Array<string>} [countries] countries codes
     * @param {Array<number>} [storeIds] Store ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApiInterface
     */
    getResellOrdersFiltered(page?: number, size?: number, orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<Array<ResellOrder>>;

    /**
     * Regenerate resell order tracking label
     * @summary Regenerate resell order tracking label
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApiInterface
     */
    regenerateResellOrderTrackingLabel(storeId: number, orderId: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ResellAftersalesQueryServiceApi - object-oriented interface
 * @export
 * @class ResellAftersalesQueryServiceApi
 * @extends {BaseAPI}
 */
export class ResellAftersalesQueryServiceApi extends BaseAPI implements ResellAftersalesQueryServiceApiInterface {
    /**
     * 
     * @summary manual cancel order
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApi
     */
    public cancelOrder(storeId: number, orderId: string, options?: AxiosRequestConfig) {
        return ResellAftersalesQueryServiceApiFp(this.configuration).cancelOrder(storeId, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a full detail of a resell order, including: Order and line statuses and contents, Order amounts (base, fees, duty, shipping costs, services, totals), Buyer and Seller contact information, Milestones, Tracking information. 
     * @summary Get resell order detail
     * @param {number} storeId 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApi
     */
    public getResellOrder(storeId: number, id: string, options?: AxiosRequestConfig) {
        return ResellAftersalesQueryServiceApiFp(this.configuration).getResellOrder(storeId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the status history of a resell order. 
     * @summary Get resell order status history
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApi
     */
    public getResellOrderStatusHistory(storeId: number, orderId: string, options?: AxiosRequestConfig) {
        return ResellAftersalesQueryServiceApiFp(this.configuration).getResellOrderStatusHistory(storeId, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a PDF containing tracking label
     * @summary Get resell order tracking label
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApi
     */
    public getResellOrderTrackingLabel(storeId: number, orderId: string, options?: AxiosRequestConfig) {
        return ResellAftersalesQueryServiceApiFp(this.configuration).getResellOrderTrackingLabel(storeId, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filtered resell order count
     * @param {string} [orderId] Order id
     * @param {string} [status] Order status
     * @param {string} [reason] Incidence reason
     * @param {string} [buyerEmail] Buyer\&#39;s email
     * @param {string} [buyerName] Buyer\&#39;s name
     * @param {string} [buyerSurname] Buyer\&#39;s surname
     * @param {string} [sellerEmail] Seller\&#39;s email
     * @param {string} [sellerName] Seller\&#39;s name
     * @param {string} [sellerSurname] Seller\&#39;s surname
     * @param {string} [commentary] Order\&#39;s commentary
     * @param {string} [start] Start creation date
     * @param {string} [end] End creation date
     * @param {string} [disputeStatus] Dispute status
     * @param {string} [groupOrderId] Order group id
     * @param {Array<string>} [countries] Countries codes
     * @param {Array<number>} [storeIds] Store ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApi
     */
    public getResellOrdersCount(orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options?: AxiosRequestConfig) {
        return ResellAftersalesQueryServiceApiFp(this.configuration).getResellOrdersCount(orderId, status, reason, buyerEmail, buyerName, buyerSurname, sellerEmail, sellerName, sellerSurname, commentary, start, end, disputeStatus, groupOrderId, countries, storeIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get filtered resell order list
     * @param {number} [page] Page number from which to start retrieving rules
     * @param {number} [size] Number of rules displayed per page
     * @param {string} [orderId] Order id
     * @param {string} [status] Order status
     * @param {string} [reason] Incidence reason
     * @param {string} [buyerEmail] Buyer\&#39;s email
     * @param {string} [buyerName] Buyer\&#39;s name
     * @param {string} [buyerSurname] Buyer\&#39;s surname
     * @param {string} [sellerEmail] Seller\&#39;s email
     * @param {string} [sellerName] Seller\&#39;s name
     * @param {string} [sellerSurname] Seller\&#39;s surname
     * @param {string} [commentary] Order\&#39;s commentary
     * @param {string} [start] Start creation date
     * @param {string} [end] End creation date
     * @param {string} [disputeStatus] Dispute status
     * @param {string} [groupOrderId] Order group id
     * @param {Array<string>} [countries] countries codes
     * @param {Array<number>} [storeIds] Store ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApi
     */
    public getResellOrdersFiltered(page?: number, size?: number, orderId?: string, status?: string, reason?: string, buyerEmail?: string, buyerName?: string, buyerSurname?: string, sellerEmail?: string, sellerName?: string, sellerSurname?: string, commentary?: string, start?: string, end?: string, disputeStatus?: string, groupOrderId?: string, countries?: Array<string>, storeIds?: Array<number>, options?: AxiosRequestConfig) {
        return ResellAftersalesQueryServiceApiFp(this.configuration).getResellOrdersFiltered(page, size, orderId, status, reason, buyerEmail, buyerName, buyerSurname, sellerEmail, sellerName, sellerSurname, commentary, start, end, disputeStatus, groupOrderId, countries, storeIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Regenerate resell order tracking label
     * @summary Regenerate resell order tracking label
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAftersalesQueryServiceApi
     */
    public regenerateResellOrderTrackingLabel(storeId: number, orderId: string, options?: AxiosRequestConfig) {
        return ResellAftersalesQueryServiceApiFp(this.configuration).regenerateResellOrderTrackingLabel(storeId, orderId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellExpetidionApi - axios parameter creator
 * @export
 */
export const ResellExpetidionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary manual cancel order by expedition
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrderExpedition: async (storeId: number, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('cancelOrderExpedition', 'storeId', storeId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancelOrderExpedition', 'orderId', orderId)
            const localVarPath = `/itxrest/2/resell-order/store/{storeId}/cancel-order/{orderId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellExpetidionApi - functional programming interface
 * @export
 */
export const ResellExpetidionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellExpetidionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary manual cancel order by expedition
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrderExpedition(storeId: number, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrderExpedition(storeId, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellExpetidionApi - factory interface
 * @export
 */
export const ResellExpetidionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellExpetidionApiFp(configuration)
    return {
        /**
         * 
         * @summary manual cancel order by expedition
         * @param {number} storeId 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrderExpedition(storeId: number, orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancelOrderExpedition(storeId, orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellExpetidionApi - interface
 * @export
 * @interface ResellExpetidionApi
 */
export interface ResellExpetidionApiInterface {
    /**
     * 
     * @summary manual cancel order by expedition
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExpetidionApiInterface
     */
    cancelOrderExpedition(storeId: number, orderId: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ResellExpetidionApi - object-oriented interface
 * @export
 * @class ResellExpetidionApi
 * @extends {BaseAPI}
 */
export class ResellExpetidionApi extends BaseAPI implements ResellExpetidionApiInterface {
    /**
     * 
     * @summary manual cancel order by expedition
     * @param {number} storeId 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExpetidionApi
     */
    public cancelOrderExpedition(storeId: number, orderId: string, options?: AxiosRequestConfig) {
        return ResellExpetidionApiFp(this.configuration).cancelOrderExpedition(storeId, orderId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellExternalMarketServiceApi - axios parameter creator
 * @export
 */
export const ResellExternalMarketServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept dispute
         * @param {ResellOrderAcceptDispute} [resellOrderAcceptDispute] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDispute: async (resellOrderAcceptDispute?: ResellOrderAcceptDispute, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/2/external/order/dispute/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resellOrderAcceptDispute, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend order for billing
         * @param {string} groupOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingResend: async (groupOrderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupOrderId' is not null or undefined
            assertParamExists('billingResend', 'groupOrderId', groupOrderId)
            const localVarPath = `/itxrest/4/private/resell/2/external/order/{groupOrderId}/resend/billing`
                .replace(`{${"groupOrderId"}}`, encodeURIComponent(String(groupOrderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Post a new resell order after checkout to create it in the resell order core service
         * @summary Create new resell order from external market
         * @param {number} storeId 
         * @param {ResellOrder} [resellOrder] External Market resell order data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResellOrder: async (storeId: number, resellOrder?: ResellOrder, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('createResellOrder', 'storeId', storeId)
            const localVarPath = `/itxrest/4/private/resell/2/external/store/{storeId}/order`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resellOrder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary insert or update an order commentary
         * @param {ResellOrderCommentary} [resellOrderCommentary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCommentary: async (resellOrderCommentary?: ResellOrderCommentary, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/2/external/order/commentary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resellOrderCommentary, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Insert or update an order dispute resolution commentary
         * @param {ResellOrderCommentary} [resellOrderCommentary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDisputeResolutionCommentary: async (resellOrderCommentary?: ResellOrderCommentary, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/2/external/order/dispute/commentary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resellOrderCommentary, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reject dispute
         * @param {ResellOrderRejectDispute} [resellOrderRejectDispute] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDispute: async (resellOrderRejectDispute?: ResellOrderRejectDispute, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/2/external/order/dispute/reject`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resellOrderRejectDispute, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary move the order to the status indicated
         * @param {boolean} [forcedUpdate] 
         * @param {boolean} [ignoreRating] 
         * @param {boolean} [syncroOrder] 
         * @param {TrackingUpdateProposal} [trackingUpdateProposal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tracking: async (forcedUpdate?: boolean, ignoreRating?: boolean, syncroOrder?: boolean, trackingUpdateProposal?: TrackingUpdateProposal, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/resell/tracking`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (forcedUpdate !== undefined) {
                localVarQueryParameter['forcedUpdate'] = forcedUpdate;
            }

            if (ignoreRating !== undefined) {
                localVarQueryParameter['ignoreRating'] = ignoreRating;
            }

            if (syncroOrder !== undefined) {
                localVarQueryParameter['syncroOrder'] = syncroOrder;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackingUpdateProposal, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Put an existing resell order to update it in the resell order core service
         * @summary Update resell order from external market
         * @param {number} storeId 
         * @param {string} id 
         * @param {UpdateResellOrder} [updateResellOrder] External Market resell order data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResellOrder: async (storeId: number, id: string, updateResellOrder?: UpdateResellOrder, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('updateResellOrder', 'storeId', storeId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateResellOrder', 'id', id)
            const localVarPath = `/itxrest/4/private/resell/2/external/store/{storeId}/order/{id}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateResellOrder, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellExternalMarketServiceApi - functional programming interface
 * @export
 */
export const ResellExternalMarketServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellExternalMarketServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept dispute
         * @param {ResellOrderAcceptDispute} [resellOrderAcceptDispute] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptDispute(resellOrderAcceptDispute?: ResellOrderAcceptDispute, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptDispute(resellOrderAcceptDispute, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resend order for billing
         * @param {string} groupOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async billingResend(groupOrderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellEventReprocessWithInputError>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.billingResend(groupOrderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Post a new resell order after checkout to create it in the resell order core service
         * @summary Create new resell order from external market
         * @param {number} storeId 
         * @param {ResellOrder} [resellOrder] External Market resell order data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createResellOrder(storeId: number, resellOrder?: ResellOrder, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createResellOrder(storeId, resellOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary insert or update an order commentary
         * @param {ResellOrderCommentary} [resellOrderCommentary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCommentary(resellOrderCommentary?: ResellOrderCommentary, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCommentary(resellOrderCommentary, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Insert or update an order dispute resolution commentary
         * @param {ResellOrderCommentary} [resellOrderCommentary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDisputeResolutionCommentary(resellOrderCommentary?: ResellOrderCommentary, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDisputeResolutionCommentary(resellOrderCommentary, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reject dispute
         * @param {ResellOrderRejectDispute} [resellOrderRejectDispute] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectDispute(resellOrderRejectDispute?: ResellOrderRejectDispute, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellOrder>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectDispute(resellOrderRejectDispute, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary move the order to the status indicated
         * @param {boolean} [forcedUpdate] 
         * @param {boolean} [ignoreRating] 
         * @param {boolean} [syncroOrder] 
         * @param {TrackingUpdateProposal} [trackingUpdateProposal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tracking(forcedUpdate?: boolean, ignoreRating?: boolean, syncroOrder?: boolean, trackingUpdateProposal?: TrackingUpdateProposal, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tracking(forcedUpdate, ignoreRating, syncroOrder, trackingUpdateProposal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Put an existing resell order to update it in the resell order core service
         * @summary Update resell order from external market
         * @param {number} storeId 
         * @param {string} id 
         * @param {UpdateResellOrder} [updateResellOrder] External Market resell order data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateResellOrder(storeId: number, id: string, updateResellOrder?: UpdateResellOrder, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateResellOrder(storeId, id, updateResellOrder, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellExternalMarketServiceApi - factory interface
 * @export
 */
export const ResellExternalMarketServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellExternalMarketServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept dispute
         * @param {ResellOrderAcceptDispute} [resellOrderAcceptDispute] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptDispute(resellOrderAcceptDispute?: ResellOrderAcceptDispute, options?: any): AxiosPromise<ResellOrder> {
            return localVarFp.acceptDispute(resellOrderAcceptDispute, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend order for billing
         * @param {string} groupOrderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingResend(groupOrderId: string, options?: any): AxiosPromise<ResellEventReprocessWithInputError> {
            return localVarFp.billingResend(groupOrderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Post a new resell order after checkout to create it in the resell order core service
         * @summary Create new resell order from external market
         * @param {number} storeId 
         * @param {ResellOrder} [resellOrder] External Market resell order data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createResellOrder(storeId: number, resellOrder?: ResellOrder, options?: any): AxiosPromise<ResellOrder> {
            return localVarFp.createResellOrder(storeId, resellOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary insert or update an order commentary
         * @param {ResellOrderCommentary} [resellOrderCommentary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCommentary(resellOrderCommentary?: ResellOrderCommentary, options?: any): AxiosPromise<ResellOrder> {
            return localVarFp.postCommentary(resellOrderCommentary, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Insert or update an order dispute resolution commentary
         * @param {ResellOrderCommentary} [resellOrderCommentary] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDisputeResolutionCommentary(resellOrderCommentary?: ResellOrderCommentary, options?: any): AxiosPromise<ResellOrder> {
            return localVarFp.postDisputeResolutionCommentary(resellOrderCommentary, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reject dispute
         * @param {ResellOrderRejectDispute} [resellOrderRejectDispute] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectDispute(resellOrderRejectDispute?: ResellOrderRejectDispute, options?: any): AxiosPromise<ResellOrder> {
            return localVarFp.rejectDispute(resellOrderRejectDispute, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary move the order to the status indicated
         * @param {boolean} [forcedUpdate] 
         * @param {boolean} [ignoreRating] 
         * @param {boolean} [syncroOrder] 
         * @param {TrackingUpdateProposal} [trackingUpdateProposal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tracking(forcedUpdate?: boolean, ignoreRating?: boolean, syncroOrder?: boolean, trackingUpdateProposal?: TrackingUpdateProposal, options?: any): AxiosPromise<void> {
            return localVarFp.tracking(forcedUpdate, ignoreRating, syncroOrder, trackingUpdateProposal, options).then((request) => request(axios, basePath));
        },
        /**
         * Put an existing resell order to update it in the resell order core service
         * @summary Update resell order from external market
         * @param {number} storeId 
         * @param {string} id 
         * @param {UpdateResellOrder} [updateResellOrder] External Market resell order data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResellOrder(storeId: number, id: string, updateResellOrder?: UpdateResellOrder, options?: any): AxiosPromise<void> {
            return localVarFp.updateResellOrder(storeId, id, updateResellOrder, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellExternalMarketServiceApi - interface
 * @export
 * @interface ResellExternalMarketServiceApi
 */
export interface ResellExternalMarketServiceApiInterface {
    /**
     * 
     * @summary Accept dispute
     * @param {ResellOrderAcceptDispute} [resellOrderAcceptDispute] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApiInterface
     */
    acceptDispute(resellOrderAcceptDispute?: ResellOrderAcceptDispute, options?: AxiosRequestConfig): AxiosPromise<ResellOrder>;

    /**
     * 
     * @summary Resend order for billing
     * @param {string} groupOrderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApiInterface
     */
    billingResend(groupOrderId: string, options?: AxiosRequestConfig): AxiosPromise<ResellEventReprocessWithInputError>;

    /**
     * Post a new resell order after checkout to create it in the resell order core service
     * @summary Create new resell order from external market
     * @param {number} storeId 
     * @param {ResellOrder} [resellOrder] External Market resell order data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApiInterface
     */
    createResellOrder(storeId: number, resellOrder?: ResellOrder, options?: AxiosRequestConfig): AxiosPromise<ResellOrder>;

    /**
     * 
     * @summary insert or update an order commentary
     * @param {ResellOrderCommentary} [resellOrderCommentary] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApiInterface
     */
    postCommentary(resellOrderCommentary?: ResellOrderCommentary, options?: AxiosRequestConfig): AxiosPromise<ResellOrder>;

    /**
     * 
     * @summary Insert or update an order dispute resolution commentary
     * @param {ResellOrderCommentary} [resellOrderCommentary] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApiInterface
     */
    postDisputeResolutionCommentary(resellOrderCommentary?: ResellOrderCommentary, options?: AxiosRequestConfig): AxiosPromise<ResellOrder>;

    /**
     * 
     * @summary Reject dispute
     * @param {ResellOrderRejectDispute} [resellOrderRejectDispute] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApiInterface
     */
    rejectDispute(resellOrderRejectDispute?: ResellOrderRejectDispute, options?: AxiosRequestConfig): AxiosPromise<ResellOrder>;

    /**
     * 
     * @summary move the order to the status indicated
     * @param {boolean} [forcedUpdate] 
     * @param {boolean} [ignoreRating] 
     * @param {boolean} [syncroOrder] 
     * @param {TrackingUpdateProposal} [trackingUpdateProposal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApiInterface
     */
    tracking(forcedUpdate?: boolean, ignoreRating?: boolean, syncroOrder?: boolean, trackingUpdateProposal?: TrackingUpdateProposal, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Put an existing resell order to update it in the resell order core service
     * @summary Update resell order from external market
     * @param {number} storeId 
     * @param {string} id 
     * @param {UpdateResellOrder} [updateResellOrder] External Market resell order data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApiInterface
     */
    updateResellOrder(storeId: number, id: string, updateResellOrder?: UpdateResellOrder, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ResellExternalMarketServiceApi - object-oriented interface
 * @export
 * @class ResellExternalMarketServiceApi
 * @extends {BaseAPI}
 */
export class ResellExternalMarketServiceApi extends BaseAPI implements ResellExternalMarketServiceApiInterface {
    /**
     * 
     * @summary Accept dispute
     * @param {ResellOrderAcceptDispute} [resellOrderAcceptDispute] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApi
     */
    public acceptDispute(resellOrderAcceptDispute?: ResellOrderAcceptDispute, options?: AxiosRequestConfig) {
        return ResellExternalMarketServiceApiFp(this.configuration).acceptDispute(resellOrderAcceptDispute, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend order for billing
     * @param {string} groupOrderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApi
     */
    public billingResend(groupOrderId: string, options?: AxiosRequestConfig) {
        return ResellExternalMarketServiceApiFp(this.configuration).billingResend(groupOrderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Post a new resell order after checkout to create it in the resell order core service
     * @summary Create new resell order from external market
     * @param {number} storeId 
     * @param {ResellOrder} [resellOrder] External Market resell order data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApi
     */
    public createResellOrder(storeId: number, resellOrder?: ResellOrder, options?: AxiosRequestConfig) {
        return ResellExternalMarketServiceApiFp(this.configuration).createResellOrder(storeId, resellOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary insert or update an order commentary
     * @param {ResellOrderCommentary} [resellOrderCommentary] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApi
     */
    public postCommentary(resellOrderCommentary?: ResellOrderCommentary, options?: AxiosRequestConfig) {
        return ResellExternalMarketServiceApiFp(this.configuration).postCommentary(resellOrderCommentary, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Insert or update an order dispute resolution commentary
     * @param {ResellOrderCommentary} [resellOrderCommentary] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApi
     */
    public postDisputeResolutionCommentary(resellOrderCommentary?: ResellOrderCommentary, options?: AxiosRequestConfig) {
        return ResellExternalMarketServiceApiFp(this.configuration).postDisputeResolutionCommentary(resellOrderCommentary, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reject dispute
     * @param {ResellOrderRejectDispute} [resellOrderRejectDispute] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApi
     */
    public rejectDispute(resellOrderRejectDispute?: ResellOrderRejectDispute, options?: AxiosRequestConfig) {
        return ResellExternalMarketServiceApiFp(this.configuration).rejectDispute(resellOrderRejectDispute, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary move the order to the status indicated
     * @param {boolean} [forcedUpdate] 
     * @param {boolean} [ignoreRating] 
     * @param {boolean} [syncroOrder] 
     * @param {TrackingUpdateProposal} [trackingUpdateProposal] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApi
     */
    public tracking(forcedUpdate?: boolean, ignoreRating?: boolean, syncroOrder?: boolean, trackingUpdateProposal?: TrackingUpdateProposal, options?: AxiosRequestConfig) {
        return ResellExternalMarketServiceApiFp(this.configuration).tracking(forcedUpdate, ignoreRating, syncroOrder, trackingUpdateProposal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Put an existing resell order to update it in the resell order core service
     * @summary Update resell order from external market
     * @param {number} storeId 
     * @param {string} id 
     * @param {UpdateResellOrder} [updateResellOrder] External Market resell order data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellExternalMarketServiceApi
     */
    public updateResellOrder(storeId: number, id: string, updateResellOrder?: UpdateResellOrder, options?: AxiosRequestConfig) {
        return ResellExternalMarketServiceApiFp(this.configuration).updateResellOrder(storeId, id, updateResellOrder, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ZipcodesStatesRestrictedServiceApi - axios parameter creator
 * @export
 */
export const ZipcodesStatesRestrictedServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add zipcodes and states restricted for the countryCode
         * @summary Add zipcodes and states restricted for the countryCode
         * @param {string} countryCode 
         * @param {RestrictedInfo} [restrictedInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRestriction: async (countryCode: string, restrictedInfo?: RestrictedInfo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('addRestriction', 'countryCode', countryCode)
            const localVarPath = `/itxrest/4/private/resell/external/store/add-restriction/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restrictedInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete zipcodes and states restricted for the countryCode
         * @summary Delete zipcodes and states restricted for the countryCode
         * @param {string} countryCode 
         * @param {RestrictedInfo} [restrictedInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRestriction: async (countryCode: string, restrictedInfo?: RestrictedInfo, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('deleteRestriction', 'countryCode', countryCode)
            const localVarPath = `/itxrest/4/private/resell/external/store/delete-restriction/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(restrictedInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate the state and zipcode of the address
         * @param {string} snapshotId 
         * @param {number} storeId 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress: async (snapshotId: string, storeId: number, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'snapshotId' is not null or undefined
            assertParamExists('validateAddress', 'snapshotId', snapshotId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('validateAddress', 'storeId', storeId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('validateAddress', 'locale', locale)
            const localVarPath = `/itxrest/4/private/resell/external/store/{storeId}/address-validate/{snapshotId}`
                .replace(`{${"snapshotId"}}`, encodeURIComponent(String(snapshotId)))
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate the zipcode and optionally the state
         * @param {string} countryCode 
         * @param {string} zipCode 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateZipcode: async (countryCode: string, zipCode: string, state?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('validateZipcode', 'countryCode', countryCode)
            // verify required parameter 'zipCode' is not null or undefined
            assertParamExists('validateZipcode', 'zipCode', zipCode)
            const localVarPath = `/itxrest/4/private/resell/external/address/validate-zipcode/{zipCode}`
                .replace(`{${"zipCode"}}`, encodeURIComponent(String(zipCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get states and zipcodes restricted by countryCode
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zipcodesRestricted: async (countryCode: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('zipcodesRestricted', 'countryCode', countryCode)
            const localVarPath = `/itxrest/4/private/resell/external/store/zipcodes-restricted/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZipcodesStatesRestrictedServiceApi - functional programming interface
 * @export
 */
export const ZipcodesStatesRestrictedServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZipcodesStatesRestrictedServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * Add zipcodes and states restricted for the countryCode
         * @summary Add zipcodes and states restricted for the countryCode
         * @param {string} countryCode 
         * @param {RestrictedInfo} [restrictedInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addRestriction(countryCode: string, restrictedInfo?: RestrictedInfo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addRestriction(countryCode, restrictedInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete zipcodes and states restricted for the countryCode
         * @summary Delete zipcodes and states restricted for the countryCode
         * @param {string} countryCode 
         * @param {RestrictedInfo} [restrictedInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRestriction(countryCode: string, restrictedInfo?: RestrictedInfo, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRestriction(countryCode, restrictedInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate the state and zipcode of the address
         * @param {string} snapshotId 
         * @param {number} storeId 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateAddress(snapshotId: string, storeId: number, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestrictedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateAddress(snapshotId, storeId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Validate the zipcode and optionally the state
         * @param {string} countryCode 
         * @param {string} zipCode 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateZipcode(countryCode: string, zipCode: string, state?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestrictedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateZipcode(countryCode, zipCode, state, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get states and zipcodes restricted by countryCode
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zipcodesRestricted(countryCode: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RestrictedInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zipcodesRestricted(countryCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ZipcodesStatesRestrictedServiceApi - factory interface
 * @export
 */
export const ZipcodesStatesRestrictedServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZipcodesStatesRestrictedServiceApiFp(configuration)
    return {
        /**
         * Add zipcodes and states restricted for the countryCode
         * @summary Add zipcodes and states restricted for the countryCode
         * @param {string} countryCode 
         * @param {RestrictedInfo} [restrictedInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRestriction(countryCode: string, restrictedInfo?: RestrictedInfo, options?: any): AxiosPromise<void> {
            return localVarFp.addRestriction(countryCode, restrictedInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete zipcodes and states restricted for the countryCode
         * @summary Delete zipcodes and states restricted for the countryCode
         * @param {string} countryCode 
         * @param {RestrictedInfo} [restrictedInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRestriction(countryCode: string, restrictedInfo?: RestrictedInfo, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRestriction(countryCode, restrictedInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate the state and zipcode of the address
         * @param {string} snapshotId 
         * @param {number} storeId 
         * @param {string} locale 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateAddress(snapshotId: string, storeId: number, locale: string, options?: any): AxiosPromise<RestrictedResult> {
            return localVarFp.validateAddress(snapshotId, storeId, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate the zipcode and optionally the state
         * @param {string} countryCode 
         * @param {string} zipCode 
         * @param {string} [state] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateZipcode(countryCode: string, zipCode: string, state?: string, options?: any): AxiosPromise<RestrictedResult> {
            return localVarFp.validateZipcode(countryCode, zipCode, state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get states and zipcodes restricted by countryCode
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zipcodesRestricted(countryCode: string, options?: any): AxiosPromise<RestrictedInfo> {
            return localVarFp.zipcodesRestricted(countryCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ZipcodesStatesRestrictedServiceApi - interface
 * @export
 * @interface ZipcodesStatesRestrictedServiceApi
 */
export interface ZipcodesStatesRestrictedServiceApiInterface {
    /**
     * Add zipcodes and states restricted for the countryCode
     * @summary Add zipcodes and states restricted for the countryCode
     * @param {string} countryCode 
     * @param {RestrictedInfo} [restrictedInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApiInterface
     */
    addRestriction(countryCode: string, restrictedInfo?: RestrictedInfo, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete zipcodes and states restricted for the countryCode
     * @summary Delete zipcodes and states restricted for the countryCode
     * @param {string} countryCode 
     * @param {RestrictedInfo} [restrictedInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApiInterface
     */
    deleteRestriction(countryCode: string, restrictedInfo?: RestrictedInfo, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Validate the state and zipcode of the address
     * @param {string} snapshotId 
     * @param {number} storeId 
     * @param {string} locale 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApiInterface
     */
    validateAddress(snapshotId: string, storeId: number, locale: string, options?: AxiosRequestConfig): AxiosPromise<RestrictedResult>;

    /**
     * 
     * @summary Validate the zipcode and optionally the state
     * @param {string} countryCode 
     * @param {string} zipCode 
     * @param {string} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApiInterface
     */
    validateZipcode(countryCode: string, zipCode: string, state?: string, options?: AxiosRequestConfig): AxiosPromise<RestrictedResult>;

    /**
     * 
     * @summary Get states and zipcodes restricted by countryCode
     * @param {string} countryCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApiInterface
     */
    zipcodesRestricted(countryCode: string, options?: AxiosRequestConfig): AxiosPromise<RestrictedInfo>;

}

/**
 * ZipcodesStatesRestrictedServiceApi - object-oriented interface
 * @export
 * @class ZipcodesStatesRestrictedServiceApi
 * @extends {BaseAPI}
 */
export class ZipcodesStatesRestrictedServiceApi extends BaseAPI implements ZipcodesStatesRestrictedServiceApiInterface {
    /**
     * Add zipcodes and states restricted for the countryCode
     * @summary Add zipcodes and states restricted for the countryCode
     * @param {string} countryCode 
     * @param {RestrictedInfo} [restrictedInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApi
     */
    public addRestriction(countryCode: string, restrictedInfo?: RestrictedInfo, options?: AxiosRequestConfig) {
        return ZipcodesStatesRestrictedServiceApiFp(this.configuration).addRestriction(countryCode, restrictedInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete zipcodes and states restricted for the countryCode
     * @summary Delete zipcodes and states restricted for the countryCode
     * @param {string} countryCode 
     * @param {RestrictedInfo} [restrictedInfo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApi
     */
    public deleteRestriction(countryCode: string, restrictedInfo?: RestrictedInfo, options?: AxiosRequestConfig) {
        return ZipcodesStatesRestrictedServiceApiFp(this.configuration).deleteRestriction(countryCode, restrictedInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate the state and zipcode of the address
     * @param {string} snapshotId 
     * @param {number} storeId 
     * @param {string} locale 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApi
     */
    public validateAddress(snapshotId: string, storeId: number, locale: string, options?: AxiosRequestConfig) {
        return ZipcodesStatesRestrictedServiceApiFp(this.configuration).validateAddress(snapshotId, storeId, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate the zipcode and optionally the state
     * @param {string} countryCode 
     * @param {string} zipCode 
     * @param {string} [state] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApi
     */
    public validateZipcode(countryCode: string, zipCode: string, state?: string, options?: AxiosRequestConfig) {
        return ZipcodesStatesRestrictedServiceApiFp(this.configuration).validateZipcode(countryCode, zipCode, state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get states and zipcodes restricted by countryCode
     * @param {string} countryCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZipcodesStatesRestrictedServiceApi
     */
    public zipcodesRestricted(countryCode: string, options?: AxiosRequestConfig) {
        return ZipcodesStatesRestrictedServiceApiFp(this.configuration).zipcodesRestricted(countryCode, options).then((request) => request(this.axios, this.basePath));
    }
}


